import { Column, ColumnType } from "@/shared/components/table/table.model";
import { ClusterInviteFragment } from "@/core/graphql/graphql";
import { extractProperty } from "@/utils/extract-property";
import { TemplateRef } from "@angular/core";

export const INVITES_COLUMNS: (actionsTemplateReference: TemplateRef<any>) =>
  Column<ClusterInviteFragment>[] = (template: TemplateRef<any>) => [
    {
      columnId: 'email',
      caption: 'E-Mail',
      fieldSelector: (invite: ClusterInviteFragment) => extractProperty(invite.email),
    },
    {
      columnId: 'actions',
      caption: 'Actions',
      fieldSelector: (c: ClusterInviteFragment) => extractProperty(c),
      type: ColumnType.Template,
      template: template,
    },
  ];
